module.exports = __webpack_public_path__ + "img/wximg16.17b9cbef.png";